import { render } from "./ContainerSelector.vue?vue&type=template&id=634f6fc6&scoped=true"
import script from "./ContainerSelector.vue?vue&type=script&lang=js"
export * from "./ContainerSelector.vue?vue&type=script&lang=js"

import "./ContainerSelector.vue?vue&type=style&index=0&id=634f6fc6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634f6fc6"]])

export default __exports__